import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { isThisYear } from 'date-fns';

@Pipe({
  name: 'newsDate',
  standalone: true,
})
export class NewsDatePipe implements PipeTransform {
  datePipe = new DatePipe('nl-NL');

  transform(date: string, ...args: unknown[]): string | null {
    if (!date) {
      return null;
    }

    if (isThisYear(date)) {
      return this.datePipe.transform(date, 'd MMMM');
    }

    return this.datePipe.transform(date, 'd MMMM y');
  }

  isThisYear(date: string) {
    return isThisYear(date);
  }
}
